import React, { useState } from "react";
import SocialDataService from "../../services/SocialService";


const AddSocial = () => {
  const initialSocialState = {
    id: null,
    name:"",
    icon:"",
    link:"",
    image:null,
    published: false
  };
  const [social, setSocial] = useState(initialSocialState);
  const [submitted, setSubmitted] = useState(false);
  const [servermessage, setServermessage] = useState("You submitted successfully!");
  const [alert, setAlert] = useState("alert alert-danger");
  const [image, setImage] = useState(null);
  // console.log(social)

  const handleInputChange = e => {
    const { name, value } = e.target;
    setSocial({ ...social, [name]: value });
  };

  const handleImageInputChange = e => {
    const { name, value } = e.target;
    const inputimage=e.target.files[0];
    setImage(inputimage)
    setSocial({ ...social, [name]: inputimage });
  };


  const saveSocial = () => {
    var data = {
      name: social.name,
      image: social.image,
      icon: social.icon,
      link: social.link,
    };
    // console.log(data)
    SocialDataService.create(data)
      .then(response => {
        
        setSocial({
          id: response.data.id,
          name: response.data.name,
          link: response.data.link,
          published: response.data.published
        });
        setSubmitted(true);
        console.log(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  const newSocial = () => {
    setSocial(initialSocialState);
    setSubmitted(false);
  };

  return (

    <div className="container pb-10">
     
     
      <h1 className="text-1xl lg:text-1xl font-semibold py-10"> Add Social Media</h1>
      <div>
      {submitted?(<div className="bg-green-100 border border-green-700 text-clay-500 px-4 py-3 rounded relative"   role="alert">
              <p style={{marginBottom: "0"}} >{servermessage}</p>
      </div>):(<><p style={{marginBottom: "0"}} ></p>
      </>)}
       <br></br>
       </div>
         
            <form className="w-full">

            <div className="md:flex md:items-center mb-6">
    <div className="md:w-1/3">
      <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" htmlFor="inline-full-name">
        Name
      </label>
    </div>
    <div className="md:w-2/3">
      <input className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="name" name="name" type="text" value={social.name} 
       
              required
               
              onChange={handleInputChange}
              />
    </div>
  </div>


  <div className="md:flex md:items-center mb-6">
    <div className="md:w-1/3">
      <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" htmlFor="inline-full-name">
       Link
      </label>
    </div>
    <div className="md:w-2/3">
      <input className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="link" name="link" type="text" value={social.link} 
       
              required
               
              onChange={handleInputChange}
              />
    </div>
  </div>



  <div className="md:flex md:items-center mb-6">
    <div className="md:w-1/3">
      <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4" htmlFor="inline-full-name">
       Icon
      </label>
    </div>
    <div className="md:w-2/3">
      <input className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-500 leading-tight focus:outline-none focus:bg-white focus:border-purple-500" id="icon" name="icon" type="text" value={social.icon} 
       
              required
               
              onChange={handleInputChange}
              />
    </div>
  </div>


  
  

       

           
        </form>
  

        <div className="md:flex md:items-center">
    <div className="md:w-1/3">
    
 </div>
    <div className="md:w-2/3 grid grid-cols-2 gap-40">
     


    {submitted ? (
        <div>
          {/* <div className={alert} role="alert">
          {servermessage}
</div> */}
           
<button className="shadow bg-green-800 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"  
          type="submit" onClick={newSocial}>
            Add New
          </button>
        </div>
      ) : (
        <>
       <button className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"  
          type="submit" onClick={saveSocial}  >
            Submit
          </button>
        </>
      )}

        


    </div>
  </div>
 
 </div>
  );
};
export default AddSocial;